module.exports = __webpack_public_path__ + "static/media/tut-5.487328e1.png";